import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createSession, CreateSessionParams } from '../../services/backendService';

export const useCreateSession = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['createSession'],
    mutationFn: (params: CreateSessionParams) => createSession(params),
    onSuccess: (data) => {
      if (data.id) {
        // Invalidate relevant queries that might depend on having a valid session
        queryClient.invalidateQueries({ queryKey: ['services'] });
      }
    },
  });
};
